// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AccountingExportCloseMonthController = function ($scope, $http, AccountingExportSettings, gettextCatalog, gettext,
    PUtill, DatepickerUtils) {
    $scope.canCloseMonth = function () {
        if ($scope.dto == null || $scope.preview == null)
            return false;
        if ($scope.preview.IsTooFarInFuture)
            return false;
        if ($scope.dto.ConfirmedIsInFuture !== $scope.preview.IsInFuture)
            return false;
        if ($scope.dto.ConfirmedHasUnexportedPostings !== $scope.preview.HasUnexportedPostings)
            return false;
        return true;
    };

    function load() {
        $scope.preview = null;
        $scope.dto = null;

        $http({
            method: "GET",
            url: "/api/v1/AccountingCloseMonth",
            data: $scope.dto
        }).then(function (response) {
            let data = response.data;
            data.NewFinalizedDate = DatepickerUtils.parseBerlinDate(data.NewFinalizedDate);
            data.NewFirstOpenDate = DatepickerUtils.parseBerlinDate(data.NewFirstOpenDate);
            
            $scope.preview = data;
            $scope.dto = {
                Year: data.NewFinalizedDate.getFullYear(),
                Month: data.NewFinalizedDate.getMonth() + 1,
                ConfirmedIsInFuture: false,
                ConfirmedHasUnexportedPostings: false
            };
        });

        AccountingExportSettings.get({},
            function (accountingSettings) {
                $scope.currentFinalizedDate = accountingSettings.FinalizedDate;
            });
    }
    load();

    $scope.closeMonth = function () {
        if (!$scope.canCloseMonth())
            return;
        $scope.yesCancel(gettextCatalog.getString(gettext('Close month')),
            gettextCatalog.getString(gettext('Do you really want to close the month now? This can not be undone.')), closeMonth);
    };

    function closeMonth() {
        if (!$scope.canCloseMonth())
            return;
        $http({
            method: "POST",
            url: "/api/v1/AccountingCloseMonth",
            data: $scope.dto
        }).then(function () {
            load();
            $scope.notifySuccess();
        });
    }
};

AccountingExportCloseMonthController.$inject = ['$scope', '$http', 'AccountingExportSettings', 'gettextCatalog',
    'gettext', 'PUtill', 'DatepickerUtils'];
